// autogenerated by channel_search/generate.py -- do not edit
import { TelemetryApiWebsocketError } from "@skydio/pbtypes/pbtypes/tools/telemetry_api/telemetry_api_pb";
export { TelemetryApiWebsocketError };

export const TELEMETRY_API_ERROR_PB = {
  channel: "TELEMETRY_API_ERROR_PB",
  type: TelemetryApiWebsocketError.deserializeBinary
};
